import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0878BF] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="/FMAL_Logo_Transparent.png" 
              alt="Find Me A Lender" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm mb-4">
              Australia's trusted mortgage brokers providing tailored finance solutions for home, personal, and business loans.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/624072684675262" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#6793D1] transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://www.instagram.com/find_me_a_lender/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#6793D1] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/find-me-a-lender/"
                target="_blank"
                rel="nooper noreferrer"
                className="hover:text-[#6793D1] transition-colors"
                ><Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm hover:text-[#6793D1] transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm hover:text-[#6793D1] transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('team')} className="text-sm hover:text-[#6793D1] transition-colors">
                  Our Team
                </button>
              </li>
              <li>
                <Link to="/learn-more" className="text-sm hover:text-[#6793D1] transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/career" className="text-sm hover:text-[#6793D1] transition-colors">
                  Career
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-sm">Home Loan</li>
              <li className="text-sm">Asset Finance</li>
              <li className="text-sm">Personal Loan</li>
              <li className="text-sm">Commercial Loan</li>
              <li className="text-sm">Refinancing</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <a href="https://www.google.com/maps/dir//The+Hub,+Old+Coach+Rd,+Upper+Coomera+QLD+4209/@-27.8560768,153.305088,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x6b9113f668f91425:0x98cb96be0c32091c!2m2!1d153.2995599!2d-27.8528332?entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#6793D1] transition-colors"><MapPin className="h-5 w-5 flex-shrink-0 mt-0.5 hover:text-[#6793D1] transition-colors" style={{color: 'rgb(255, 255, 255)'}, {hover:"text-[#6793D1] transition-colors"}} /></a>
                <span className="text-sm hover:text-[#6793D1] transition-colors">
                  <a href="https://www.google.com/maps/dir//The+Hub,+Old+Coach+Rd,+Upper+Coomera+QLD+4209/@-27.8560768,153.305088,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x6b9113f668f91425:0x98cb96be0c32091c!2m2!1d153.2995599!2d-27.8528332?entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#6793D1] transition-colors">Head Office: THE HUB, Shop 14, 90 Days Road, Upper Coomera QLD 4209</a>
                </span>
              </li>
              {/* <li className="flex items-start space-x-2">
                <a href="" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#6793D1] transition-colors"><MapPin className="h-5 w-5 flex-shrink-0 mt-0.5 hover:text-[#6793D1] transition-colors" style={{color: 'rgb(255, 255, 255)'}, {hover:"text-[#6793D1] transition-colors"}} /></a>
                <span className="text-sm hover:text-[#6793D1] transition-colors">
                  <a href="" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#6793D1] transition-colors">Cairns Office: 266 Mulgrave Rd, Westcourt QLD 4870</a>
                </span>
              </li> */}
              <li className="flex items-center space-x-2">
                <a href="tel:1300078494" className="text-sm hover:text-[#6793D1] transition-colors"><Phone className="h-5 w-5 hover:text-[#6793D1] transition-colors" style={{ color: 'white' }, {hover:"text-[#6793D1] transition-colors"}} /></a>
                <a href="tel:1300078494" className="text-sm hover:text-[#6793D1] transition-colors">
                  Phone: 1300 078 494
                </a>
                <a href="tel:0466553335" className="text-sm hover:text-[#6793D1] transition-colors">
                  Mobile: 0466 553 335
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <a href="mailto:info@findmealender.com.au" className="text-sm hover:text-[#6793D1] transition-colors"><Mail className="h-5 w-5 hover:text-[#6793D1] transition-colors" style={{ color: 'white' }, {hover:"text-[#6793D1] transition-colors"}} /></a>
                <a href="mailto:info@findmealender.com.au" className="text-sm hover:text-[#6793D1] transition-colors">
                  info@findmealender.com.au
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#6793D1]">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-center md:text-left">
              © 2025 Find Me A Lender - ACL: 481374. All Rights Reserved.
            </p>
            <div className="flex space-x-6">
               <Link to="/privacy" className="text-sm hover:text-[#6793D1] transition-colors">
                Privacy Policy &amp; Credit Guide
              </Link>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="text-sm hover:text-[#6793D1] transition-colors"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
